import { ApiClient } from "@/services/apiClient";
import type { AutocompleteCollectibleItem, Collectible, CollectibleId, CollectibleSearchListItem } from "@/services/collectibles/collectiblesTypes";
import type { CategoryId } from "@/services/collection/categories";
import type { CatalogueFilter } from "@/services/collectibles/collectiblesFilter";

type ApiResponse_CollectibleSearch = {
  totalCount: number;
  collectibles: CollectibleSearchListItem[];
};

export const searchCollectibles = (filter: CatalogueFilter): Promise<ApiResponse_CollectibleSearch> => {
  const urlParams = filter.createApiParams();
  return ApiClient.getPublic<ApiResponse_CollectibleSearch>("api-public/collectible", urlParams).then(({ data }) => data);
};

export const fetchCollectibleById = async (id: CollectibleId): Promise<Collectible> => {
  const url = "api-public/collectible/" + id;
  return ApiClient.getPublic<Collectible>(url).then(({ data }) => data);
};

export const searchCollectibleForAutocomplete = async (categoryId: CategoryId, q: string): Promise<AutocompleteCollectibleItem[]> => {
  const url = "api-public/collectible/autocomplete/" + categoryId;
  const params = { q };
  return ApiClient.getPublic<AutocompleteCollectibleItem[]>(url, params).then(({ data }) => data);
};
